import React from "react";
import "./about-as-welcome-white-foodliners.scss";

const WelcomeWhiteFoodliners = ({ welcomeAboutusData }) => {
  return (
    <>
      <div className="about-as-welcome-white-foodliners-section">
        <div className="container">
          <div className="grid">
            <div className="grid-items">
              <img
                src={
                  welcomeAboutusData
                    ? welcomeAboutusData.about_section.image
                    : ""
                }
                alt="WhitesAboutImage"
              />
            </div>
            <div className="grid-items">
              <h1>
                {welcomeAboutusData
                  ? welcomeAboutusData.about_section.title
                  : ""}
              </h1>
              <p
                dangerouslySetInnerHTML={{
                  __html: welcomeAboutusData
                    ? welcomeAboutusData.about_section.description
                    : "",
                }}
              >
                { }
              </p>
              {/* <span>
                            Joe and Frances retired in the mid-1990’s. Joe’s love for the business was inspired by
                            visits to his paternal grandparents in SE Kansas who operated small grocery stores in that region. After working at several stores in Dodge City, KS, and Denver, CO, he realized a dream with the purchase of his first store.
                        </span> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WelcomeWhiteFoodliners;
